import { useEffect, useMemo, useState } from 'react';
import { buildEventParticipantScopeTabs } from './eventParticipantsPanelDataUtils';

export default function useEventParticipantPartScope({
  effectiveGroupEvents = [],
  selectedEventId = '',
  pickFirstString,
}) {
  const [participantPartScopeEventUuid, setParticipantPartScopeEventUuid] = useState('all');

  useEffect(() => {
    if (effectiveGroupEvents.length > 1) {
      setParticipantPartScopeEventUuid((prev) => {
        if (prev === 'all') return prev;
        const exists = effectiveGroupEvents.some(
          (event) => String(event?.event_uuid || '') === String(prev)
        );
        return exists ? prev : 'all';
      });
      return;
    }
    const singleEventUuid = String(
      effectiveGroupEvents?.[0]?.event_uuid || selectedEventId || ''
    ).trim();
    setParticipantPartScopeEventUuid(singleEventUuid || 'all');
  }, [effectiveGroupEvents, selectedEventId]);

  const participantPartScopeTabs = useMemo(() => {
    return buildEventParticipantScopeTabs({
      effectiveGroupEvents,
      pickFirstString,
    });
  }, [effectiveGroupEvents, pickFirstString]);

  return {
    participantPartScopeEventUuid,
    setParticipantPartScopeEventUuid,
    participantPartScopeTabs,
  };
}
